import config from "config/config";
import { PlaneWithClockIcon, WorldIcon, BanknotesIcon } from "styles/icons";

export const HOW_SCORE_IS_CALCULATED_AIRLINE_ITEMS = [
  {
    icon: PlaneWithClockIcon,
    header: "on_time_performance",
    description: "airline_on_time_performance_desc",
  },
  { icon: WorldIcon, header: "service_quality", description: "airline_service_quality_desc" },
  { icon: BanknotesIcon, header: "claim_processing", description: "airline_claim_processing_desc" },
];

export const AIRLINES_METHODOLOGY_PDF_LINK =
  "https://static.airhelp.com/pdf/2019-airline-score/methodology_airhelp_score_2019__global_airline_rankings-en_us.pdf";

export const AIRPORT_POST_IMAGE = `${config.staticUrl}/i/airhelp-score/airport_ranking_featured.jpeg`;
